//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userListApi, groupListApi, levelListApi, levelUseApi, levelDeleteApi } from '@/api/user';
import creatGrade from './creatGrade';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  name: 'Grade',
  filters: {
    typeFilter: function typeFilter(status) {
      var statusMap = {
        wechat: '微信用户',
        routine: '小程序你用户',
        h5: 'H5用户'
      };
      return statusMap[status];
    }
  },
  components: {
    creatGrade: creatGrade
  },
  data: function data() {
    return {
      listLoading: true,
      userInfo: {},
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    checkPermi: checkPermi,
    seachList: function seachList() {
      this.getList();
    },
    add: function add() {
      this.$refs.grades.dialogVisible = true;
      this.userInfo = {};
    },
    edit: function edit(id) {
      // this.$refs.grades.info(id)
      this.userInfo = id;
      this.$refs.grades.dialogVisible = true;
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      levelListApi().then(function (res) {
        _this.tableData.data = res;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this2 = this;
      this.$modalSure('删除吗？删除会导致对应用户等级数据清空，请谨慎操作！').then(function () {
        levelDeleteApi(id).then(function () {
          _this2.$message.success('删除成功');
          _this2.getList();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this3 = this;
      if (row.isShow == false) {
        row.isShow = !row.isShow;
        levelUseApi({
          id: row.id,
          isShow: row.isShow
        }).then(function () {
          _this3.$message.success('修改成功');
          _this3.getList();
        }).catch(function () {
          row.isShow = !row.isShow;
        });
      } else {
        this.$modalSure('该操作会导致对应用户等级隐藏，请谨慎操作').then(function () {
          row.isShow = !row.isShow;
          levelUseApi({
            id: row.id,
            isShow: row.isShow
          }).then(function () {
            _this3.$message.success('修改成功');
            _this3.getList();
          }).catch(function () {
            row.isShow = !row.isShow;
          });
        });
      }
    }
  }
};